import { env } from "@/env";
import type { CustomProduct } from "@apptus/esales-api";
import z from "zod";

export function getNorceUrlByKey(key: string) {
  if (key.includes(env.NEXT_PUBLIC_NORCE_IMAGE_CDN)) {
    return key;
  }

  return `${env.NEXT_PUBLIC_NORCE_IMAGE_CDN}/${key}`;
}

export const productImageSchema = z.object({
  id: z.string(),
  alt: z.string(),
  src: z.string(),
});

export type ProductImage = z.infer<typeof productImageSchema>;

export default function getImagesFromProduct(
  product: CustomProduct,
  exhaustive = false,
): ProductImage[] {
  if (product.typedCustom?.json) {
    const {
      v2_productMainImageKey,
      v2_productAdditionalImageKey,
      v2_variantMainImageKey,
      v2_variantAdditionalImageKey,
    } = product.typedCustom.json;

    const images: string[] = [];

    if (v2_variantMainImageKey) {
      images.push(v2_variantMainImageKey);
    } else if (v2_productMainImageKey) {
      images.push(v2_productMainImageKey);
    }

    if (exhaustive) {
      images.push(
        ...(v2_variantAdditionalImageKey ?? []),
        ...(v2_productAdditionalImageKey ?? []),
      );
    } else if (v2_variantAdditionalImageKey?.length) {
      images.push(...v2_variantAdditionalImageKey);
    } else if (v2_productAdditionalImageKey?.length) {
      images.push(...v2_productAdditionalImageKey);
    }

    return Array.from(new Set(images)).map((imageKey) => ({
      id: imageKey,
      alt: `${product.key}_image_${imageKey}`,
      src: getNorceUrlByKey(imageKey),
    }));
  }

  return [];
}
